import styled from 'styled-components';

export const Container = styled.header`
  background-color: #fff;
  box-shadow: 0 -10px 15px rgba(0, 0, 0, 0.3);
`;
